export const money = (v) => `$${(Number(v) || 0).toFixed(2)}`;
export const fmtHours = (sec) => {
  const h = (Number(sec) || 0) / 3600;
  return h >= 10 ? `${Math.round(h)} h` : h >= 1 ? `${h.toFixed(1)} h` : `${Math.round(h * 60)} min`;
};
export const fmtDate = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  // Calendar days, not 24-hour blocks: 11 pm yesterday is "yesterday" at 9 am today.
  const midnight = (x) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const days = Math.round((midnight(new Date()) - midnight(d)) / 86400000);
  const time = d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  if (days < 1) return `today ${time}`;
  if (days === 1) return `yesterday ${time}`;
  if (days < 7) return `${days} days ago`;
  return d.toLocaleDateString([], { day: "numeric", month: "short", year: days > 300 ? "numeric" : undefined });
};
